import * as React from "react";
import styled, { css } from "styled-components";

import { sentenceCase } from "src/library/utils/string-manipulations";
import { ThemeType } from "src/library/utils/theme";
import {
  Text,
  ITextProps
} from "src/library/components/Text/Text";
import { OrderPaymentStatus as OrderPaymentStatusType } from "src/core/orders/api/orders.api";
import { orderPaymentStatusToHuman } from "src/modules/payment/utils";

interface OrderPaymentStatusProps extends ITextProps {
status: OrderPaymentStatusType;
}

interface StyledOrderPaymentStatusProps {
  status: OrderPaymentStatusType;
}

/**
 * The order payment status
 */
const OrderPaymentStatus = ({ status, ...rest }: OrderPaymentStatusProps) => {
  return (
    <StyledOrderPaymentStatus
      status={status}
      {...rest}
    >
      {sentenceCase(orderPaymentStatusToHuman(status))}
    </StyledOrderPaymentStatus>
  );
};

export default OrderPaymentStatus;

const StyledOrderPaymentStatus = styled(Text)<StyledOrderPaymentStatusProps>`
  ${({ status, theme }) => css`
    color: ${setStatusColor(status, theme)};
  `};
`;

/**
 * Sets the status colour depending on the status given
 */
const setStatusColor = (status: OrderPaymentStatusType, theme: ThemeType): string => {
  switch (status) {
    default:
    case OrderPaymentStatusType.UNCAPTURED:
    case OrderPaymentStatusType.REFUNDED:
    case OrderPaymentStatusType.PARTIAL_REFUNDED:
      return theme.colors.warn;

    case OrderPaymentStatusType.CAPTURED:
      return theme.colors.success;

    case OrderPaymentStatusType.CANCELED:
    case OrderPaymentStatusType.REFUND_FAILED:
    case OrderPaymentStatusType.FAILED:
      return theme.colors.error;
  }
};
